type ThumbsUpIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const ThumbsUpIcon = (props: ThumbsUpIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_11787_95062)">
      <path
        d="M4.66634 14.6673H2.66634C2.31272 14.6673 1.97358 14.5268 1.72353 14.2768C1.47348 14.0267 1.33301 13.6876 1.33301 13.334V8.66732C1.33301 8.3137 1.47348 7.97456 1.72353 7.72451C1.97358 7.47446 2.31272 7.33398 2.66634 7.33398H4.66634M9.33301 6.00065V3.33398C9.33301 2.80355 9.12229 2.29484 8.74722 1.91977C8.37215 1.5447 7.86344 1.33398 7.33301 1.33398L4.66634 7.33398V14.6673H12.1863C12.5079 14.671 12.8199 14.5583 13.0649 14.35C13.31 14.1417 13.4715 13.8519 13.5197 13.534L14.4397 7.53398C14.4687 7.34289 14.4558 7.14777 14.4019 6.96215C14.348 6.77653 14.2544 6.60485 14.1276 6.45899C14.0008 6.31314 13.8437 6.19661 13.6674 6.11746C13.4911 6.03832 13.2996 5.99846 13.1063 6.00065H9.33301Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11787_95062">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
